import { render, staticRenderFns } from "./opinionModal.vue?vue&type=template&id=2d1c0f26&scoped=true&"
import script from "./opinionModal.vue?vue&type=script&lang=js&"
export * from "./opinionModal.vue?vue&type=script&lang=js&"
import style0 from "./opinionModal.vue?vue&type=style&index=0&id=2d1c0f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c0f26",
  null
  
)

export default component.exports